import { useTranslation } from 'react-i18next';
// Utils
import { cn } from '@repo/zolintra-utils';
// Components
import { Button, Icon, PageLayout } from '@repo/zolintra-ui';
import UnitResourceSettings from './formTemplates/settings/UnitResourceSettings';
import DelayAndPlacesManagementForm from './formTemplates/settings/DelayAndPlacesManagementForm';
// Hooks
import { useAppContext } from '../../store/AppContext';
import useResources from '../../hooks/domain/useResources';
import useAuth from '../../hooks/useAuth';
// Styles
import styles from './Settings.module.css';
import hasPermission, { PERMISSIONS } from '../../permissions/hasPermission';

function Configuration() {
  // Hooks
  const { t } = useTranslation();
  const [{ user }] = useAppContext();
  const { getResourceDisplayName } = useResources();
  const { handleLogout } = useAuth();

  const hasGetAnyResourcePermission = (
    hasPermission(PERMISSIONS.GET_ANY_RESOURCE, user.prm)
    && hasPermission(PERMISSIONS.IDENTITY_ACCESS_GET_ANY_RESOURCE, user.prm)
  );

  const hasGetConfigurationPermission = (
    hasPermission(PERMISSIONS.GET_CONFIGURATION, user.prm)
  );

  return (
    <PageLayout
      title={`${t('settings.title')} - ${t('remoteWorkingAndLeave.title')}`}
      user={{
        name: getResourceDisplayName(user, true),
        photo: user.photo,
      }}
      logout={{ label: t('common.logout'), handleLogout }}
    >
      <div className={styles.wrapper}>
        <div className={cn([styles.actions, 'margin-bottom-m'])}>
          <a href="/">
            <Button onClick={() => {}} variant="bordered" color="transparent" shape="rectangle">
              <Icon icon="arrowSquareLeft" />
              {t('settings.backButton')}
            </Button>
          </a>
        </div>

        {hasGetConfigurationPermission ? (
          <DelayAndPlacesManagementForm />
        ) : null}

        {hasGetConfigurationPermission && hasGetAnyResourcePermission ? (
          <div className={styles.separator} />
        ) : null}

        {hasGetAnyResourcePermission ? (
          <>
            <h2 className={styles.title}>
              {t('settings.resource.title')}
            </h2>

            <UnitResourceSettings />
          </>
        ) : null}
      </div>
    </PageLayout>
  );
}

Configuration.propTypes = {};

export default Configuration;
